module.exports = __webpack_public_path__ + "static/media/close.dff71e74.svg";